export const normalizeVoucherDiscounts = discounts =>
  Array.isArray(discounts) ? discounts : [];



// WEBPACK FOOTER //
// ./src/utils/vouchers.js